import React from 'react';
import {globs, constant} from '../../components/utils/utils';
import {dbVals} from '../../components/utils/http';
import {getParamId2, isSensorErrVal} from '../../usa/utils/utils';
import {loadXBoards} from '../../usa/components/C18utils';
import {pInd} from '../../components/utils/paramIds';
import {lc} from '../../components/utils/landruConstants';
import {skipThisGwType} from '../utilsFui';

// Exp Temp 1..19 use input map indexes 58..76 and pearl_snaps exTemp6..exTemp24
const EXP_TEMP_INPUT_BASE=58
const EXP_TEMP_SNAP_BASE=6
const EXP_TEMP_COUNT=19

class SmartIdriveStatus extends React.Component{
  constructor(props) {
    super(props);
    this.props.getValue(props.ind, {type: "local"})
    this.state={commLoss:false, sensorMissing:false, boardIndex:-1}
    this.subscribe_updateFui=globs.events.subscribe("updateFui", this.refresh)
  }

  componentDidMount=()=>{
    this.refresh()
  }

  componentWillUnmount=()=>{
    if(this.subscribe_updateFui){this.subscribe_updateFui.remove()}
  }

  getChan=()=>{
    let zuci=this.props.zuci||""
    let parts=zuci.split("-")
    return +(parts[2]??-1)
  }

  findSmartIdriveBoard=()=>{
    let zoneInfo=this.props.zoneInfo
    if(!zoneInfo||zoneInfo.gatewayType!==1900){return null}
    let chan=this.getChan()
    if(chan<0){return null}
    return loadXBoards(this, zoneInfo).find(x=>
      +x.type===constant.MB_SLAVE_TYPE_16OUT_DTH &&
      chan>=x.startCh && chan<=x.numOuts+x.startCh-1)||null
  }

  tempPidForInput=(inp)=>{
    if(inp<EXP_TEMP_INPUT_BASE||inp>=EXP_TEMP_INPUT_BASE+EXP_TEMP_COUNT){
      return null
    }
    let snapN=inp-EXP_TEMP_INPUT_BASE+EXP_TEMP_SNAP_BASE
    return getParamId2(1900, "pearl_snaps", `exTemp${snapN}`)
  }

  readTempAtInput=(zInd, inp)=>{
    let pid=this.tempPidForInput(inp)
    if(pid==null){return null}
    let value=((dbVals.z[zInd]||{})[240]||{})[pid]
    if(value===undefined||value===null){return null}
    return +value
  }

  collectBoardTempValues=(board)=>{
    let zInd=this.props.zoneInfo?.siteZoneIndex
    let values=[]
    let tab=pInd[1900]?.pearl_sensor_config
    if(zInd!=null&&tab){
      let mappingId=getParamId2(1900, "pearl_sensor_config", "mapping")
      let boardId=getParamId2(1900, "pearl_sensor_config", "board")
      let mult=tab[2]||3
      for(let inp=EXP_TEMP_INPUT_BASE;inp<EXP_TEMP_INPUT_BASE+EXP_TEMP_COUNT;inp++){
        let ofs=inp*mult
        let mapping=+((dbVals.z[zInd]||{})[240]||{})[mappingId+ofs]||0
        let b=+((dbVals.z[zInd]||{})[240]||{})[boardId+ofs]||0
        if(mapping===lc.setup_t_InputMap_INPUTNAME_SENSOR_DTH && b===board.boardIndex){
          let value=this.readTempAtInput(zInd, inp)
          if(value!=null){values.push(value)}
        }
      }
    }
    let startInp=+board.startInp||0
    if(startInp){
      let value=this.readTempAtInput(zInd, startInp)
      if(value!=null){values.push(value)}
    }
    return values
  }

  // Only flag missing when we have a positive error/timeout reading.
  // Avoid false positives when onboard DTH is used by firmware without cloud mapping.
  evaluateSensorMissing=(board)=>{
    let values=this.collectBoardTempValues(board)
    if(!values.length){return false}
    return values.every(v=>isSensorErrVal(v))
  }

  refresh=()=>{
    let board=this.findSmartIdriveBoard()
    if(!board){
      this.setState({commLoss:false, sensorMissing:false, boardIndex:-1})
      return
    }
    let status=+board.status||0
    // Same rule as zone equipment: non-zero status other than 1 means offline
    let commLoss=!!(status&&status!==1)
    let sensorMissing=!commLoss&&this.evaluateSensorMissing(board)
    this.setState({
      commLoss,
      sensorMissing,
      boardIndex:board.boardIndex,
    })
  }

  showBanner=(title, subtitle)=>{
    return(
      <div className="zone-error-box" style={{width:"100%", clear:"both"}}>
        <div className="zone-error-title">
          <span className="material-icons-outlined zone-error-icon">error_outline</span>
          <span>{title}</span>
        </div>
        {subtitle&&
          <div className="zone-error-subtitle">{subtitle}</div>}
      </div>
    )
  }

  render(){
    if(skipThisGwType(this.props)){return null}
    let st=this.state
    if(st.commLoss){
      let boardLabel=st.boardIndex>=0?` (Expansion Board ${st.boardIndex+1})`:""
      return this.showBanner(
        `Smart iDrive communication lost${boardLabel}`,
        "The Smart iDrive board is offline. Temperature-based open/close control is unavailable until communication is restored.")
    }
    if(st.sensorMissing){
      return this.showBanner(
        "No temperature sensor detected",
        "A valid temperature reading is missing or has timed out. After the Timeout period, the configured Safety action will be applied.")
    }
    return null
  }
}

export default SmartIdriveStatus;
